// extracted by mini-css-extract-plugin
export default {"main":"KFHRus_main__yYL01","cover":"KFHRus_cover__AV+5o","flex_col":"KFHRus_flex_col__k2uIu"};